module.exports = __webpack_public_path__ + "img/loginBg.8e6417c4.png";